<script>
import moment from 'moment';

module.exports = {
  template: '#events-template',
  data: function() {
    return {
      eventShow: []
    };
  },
  methods: {
    toggleEvent: function(id) {
      let events = this.$store.state.events ? this.$store.state.events : [];
      let cars = this.$store.state.cars.active.map(car => {
        return car.license;
      });

      let i = 0;

      let event = events.reduce((result, event) => {
        if (event.id === id) {
          event.route = false;

          if (event.car && cars.indexOf(event.car.license) >= 0 && event.type !== 'varausvahvistus' && event.type !== 'ostovahvistus')
            event.route = { name: 'cars-children-section', params: { license: event.car.license, section: 'huoltohistoria' } };

          result = event;
        }

        return result;
      }, {});

      if (event.route) this.$router.push(event.route);
      else {
        if (this.eventShow.indexOf(id) >= 0) this.eventShow.splice(this.eventShow.indexOf(id), 1);
        else this.eventShow.push(id);
      }
    }
  },
  computed: {
    events: function() {
      let events = this.$store.state.events ? this.$store.state.events : [];
      let cars = this.$store.state.cars.active.map(car => {
        return car.license;
      });

      events = events.map((event, i) => {
        event.id = 'event-' + i;
        if (event.car && cars.indexOf(event.car.license) >= 0) event.route = { name: 'cars-children-section', params: { license: event.car.license, section: 'huoltohistoria' } };
        else event.route = false;
        return event;
      });

      return {
        count: events.length,
        items: events,
        loading: this.$store.state.events ? false : true
      };
    }
  }
};
</script>